//Form validation stuff
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { useNavigate } from "react-router-dom";

//Components
import { Navbar } from '../../components/navbar';
import { Input } from '../../components/input';
import { InputWrapper } from '../../components/input/input.style';
import { Button } from '../../components/button';

//Styles
import { StyledContainer, StyledMainContent, StyledForm } from "../../styles/login";


//Login Schema
const schema = yup.object().shape({
    email: yup.string().email().oneOf(['lendsqr@gmail.com'], "Email is lendsqr@gmail.com"),
    password: yup.string().oneOf(['lendsqr'], "Password is lendsqr"),
});


const LoginPage = () => {
    //Intialize the useNaviagte hook
    const navigate = useNavigate();

    //Configure validation with react-use-form and yup
    const {
        handleSubmit,
        register,
        formState: { errors },
        watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });


    //Handle form submission
    const onSubmit = values => {
        console.log(values)
        //Redirect user to dashbard
        navigate("/dashboard/users");
    }

    return (
        <>
            <StyledContainer>
                <Navbar />
                <StyledMainContent>
                    <div className="welcome-image">
                        <img src="/assets/images/lendsqr-login-image.png" alt="login" />
                    </div>
                    <div>
                        <StyledForm onSubmit={handleSubmit(onSubmit)}>
                            <h2 className="welcome-text">Welcome!</h2>
                            <p className="sub-text">Enter details to login.</p>
                            <InputWrapper>
                                <Input
                                    className="login-input"
                                    id="email"
                                    type="text"
                                    placeholder="Email"
                                    fullWidth
                                    {...register("email")}
                                    error={errors.email?.message}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Input
                                    endAdornment
                                    className="login-input"
                                    id="password"
                                    type="password"
                                    placeholder="Password"
                                    {...register("password")}
                                    error={errors.password?.message}
                                    fullWidth
                                />
                            </InputWrapper>
                            <p className="forgot-password-text">Forgot PASSWORD?</p>
                            <div style={{ marginTop: '3rem' }}>
                                <Button
                                    type="submit"
                                    disabled={
                                        Object.keys(errors).length > 0 ||
                                        Object.values(watch()).length < 1
                                    }
                                    fullWidth>
                                    LOG IN
                                </Button>
                            </div>
                        </StyledForm>
                    </div>
                </StyledMainContent>
            </StyledContainer>
        </>
    )
}

export default LoginPage